var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico_news",class:{
    ico_free: _vm.type === 'chapter_free_for_now',
    ico_sale: _vm.type === 'chapter_unlock_discount',
    ico_coinback: _vm.type === 'chapter_unlock_coinback'
  }})}
var staticRenderFns = []

export { render, staticRenderFns }